import { StructuredAddressFields } from "@/components/common/StructuredAddressFields";
import { inputClass } from "@/components/common/surfaceClasses";

export function AudienceDataDealerMapCreateFields(props: {
  name: string;
  street: string;
  city: string;
  state: string;
  postal: string;
  onName: (v: string) => void;
  onStreet: (v: string) => void;
  onCity: (v: string) => void;
  onState: (v: string) => void;
  onPostal: (v: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="min-w-0 space-y-2">
      <label className="block min-w-0 text-sm text-gray-700 dark:text-zinc-300">
        Location name
        <input
          className={`mt-1 ${inputClass}`}
          value={props.name}
          onChange={(e) => props.onName(e.target.value)}
          disabled={props.disabled}
        />
      </label>
      <StructuredAddressFields
        value={{
          street: props.street,
          city: props.city,
          state: props.state,
          postal_code: props.postal,
        }}
        onChange={(next) => {
          props.onStreet(next.street ?? "");
          props.onCity(next.city ?? "");
          props.onState(next.state ?? "");
          props.onPostal(next.postal_code ?? "");
        }}
        disabled={props.disabled}
        inputClassName={inputClass}
        labelClassName="block min-w-0 text-sm text-gray-700 dark:text-zinc-300"
      />
    </div>
  );
}
